const firebaseConfig = {
  apiKey: 'AIzaSyCn0344vtjAiELwGelZLOlDmptEjU7Ogl0',
  authDomain: 'doctors-portal-ishad.firebaseapp.com',
  projectId: 'doctors-portal-ishad',
  storageBucket: 'doctors-portal-ishad.appspot.com',
  messagingSenderId: '966975652182',
  appId: '1:966975652182:web:51e3700dd95255586716f7',
}
export default firebaseConfig
